<template>
<!--产品特色-->
  <div class="zj_productFeature">
    <div class="cnname flexcc font16rem black wow bounceIn"
      data-wow-duration="2s"
      data-wow-delay="0s"
      data-wow-offset="10"
      data-wow-iteration="1">{{$t("产品特色")}}</div>
    <div class="nameline flexcc">
      <div class="line"></div>
    </div>
    <div class="fivead_out">
    <div class="fivead_in">
      <div class="container flexrow flexlrbetween">
        <div class="container_part box_shadow2 wow"  v-for="item in fiveAdvData" :key="item.index" :class="item.index%2==0?'bounceInDown':'bounceInUp'"
        data-wow-duration="2s"
      data-wow-delay="0s"
      data-wow-offset="10"
      data-wow-iteration="1">
          <div class="pic flexcc">
            <img :src="item.icon" />
          </div>
          <div class="detail font8rem black2">{{item.detail}}</div>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
//import {WOW} from 'wowjs'
import Swiper from "swiper";
export default {
  name: "zj_productFeature",
  data() {
    return {
      fiveAdvData:[{
        index:1,
        icon:require("../../assets/Images/ui.png"),
        detail:this.$t("利用目前国际流行的前端UI包括canvas、Vue等")
      },{
        index:2,
        icon:require("../../assets/Images/zb.png"),
        detail:this.$t("整合MMT特有的几百种新零售指标")
      },{
        index:3,
        icon:require("../../assets/Images/tx.png"),
        detail:this.$t("丰富的2D/3D图库展现数据动态化、图形")
      },{
        index:4,
        icon:require("../../assets/Images/sjk.png"),
        detail:this.$t("后台利用大型数据库及相关算法进行计算")
      }]
    };
  },
  watch: {
    '$i18n.locale': function (newVal) {
        this.fiveAdvData= [{
        index:1,
        icon:require("../../assets/Images/ui.png"),
        detail:this.$t("利用目前国际流行的前端UI包括canvas、Vue等")
      },{
        index:2,
        icon:require("../../assets/Images/zb.png"),
        detail:this.$t("整合MMT特有的几百种新零售指标")
      },{
        index:3,
        icon:require("../../assets/Images/tx.png"),
        detail:this.$t("丰富的2D/3D图库展现数据动态化、图形")
      },{
        index:4,
        icon:require("../../assets/Images/sjk.png"),
        detail:this.$t("后台利用大型数据库及相关算法进行计算")
      }]
   }
  },
  mounted() {
    new this.$wow.WOW({ live: true }).init();
  },
  methods: {
    swiperSan() {
      let swiper1 = new Swiper(".fivenew_container", {
        direction: "horizontal",
        autoplay: 3000,
        speed: 1000,
        autoplayDisableOnInteraction: false,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        loop: true,
        pagination: ".swiper-pagination",
        paginationClickable: true,
        grabCursor: true, //鼠标光标
        nextButton: ".swiper-button-next",
        prevButton: ".swiper-button-prev",
        centeredSlides: true,
        slidesPerView: 3,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.zj_productFeature {
  width: 100%;
  height: 100%;
  margin-top: 4rem;
  .cnname {
    width: 100%;
  }
  .nameline {
    width: 100%;
    .line {
      width: 6rem;
      height: 0.3rem;
      background-color: #2473e3;
      border-radius: 10px;
      margin-top: 1rem;
    }
  }
  .fivead_out {
    width: 100%;
    height: 60%;
    margin: 0 auto;
    margin-top: 2rem;
    //background-color: rgba(247,250,255,0.5);
  .fivead_in {
    width: 100%;
    height: 100%;
  .container{
    width: 80%;
    height: 100%;
    margin: 0 auto;
    .container_part{
      width: 20%;
    height: 100%;
    //background-color: #fff;
    .pic{
width: 100%;
height: 20%;
margin-top: 30%;
img{
  width: 15%;
}
    }
    .name{
width: 100%;
height: 15%;
    }
    .detail{
width: 70%;
height: 35%;
margin: 0 auto;
text-align: center;
line-height: 1.5rem;
    }
    }
  }
  }
  }
}
</style>
